import { useEffect, useMemo } from "react";
import { useProductsTypeAttribute } from "../lib/react-query/useProducts";

export const usePreparedAddonsForService = (service, { search = "", orderField = "", orderDirection = "", addDefaultAddons, exclusive = false } = {}) => {
  const {
    isLoading,
    isFetching,
    data: addonsInfiniteData,
  } = useProductsTypeAttribute({
    search,
    orderField,
    orderDirection,
    serviceId: service.id,
    onPage: 1000,
    enabled: !!service.has_available_addons,
  });

  const addons = useMemo(() => {
    const flat = addonsInfiniteData?.pages?.flatMap((page) => page.data) ?? [];

    return flat.map((addon) => {
      const selectedAddon = service.addons?.find((a) => a.id === addon.id);
      const matchedService = addon.services?.find((s) => +s.service_id === +service.id);
      const qty = selectedAddon ? selectedAddon.qty : +matchedService?.qty || 0;

      return { ...addon, is_available: true, qty };
    });
  }, [addonsInfiniteData, service]);

  const totalCount = addonsInfiniteData?.pages?.[0]?.metadata?.items_count ?? 0;

  useEffect(() => {
    if (addDefaultAddons && !service.isAddonsInitialized && !isLoading && addons.length) {
      const defaultAddons = addons.filter((a) => a.qty > 0);
      addDefaultAddons(service.id, exclusive ? defaultAddons.slice(0, 1) : defaultAddons);
    }
  }, [addDefaultAddons, addons, isLoading, service.isAddonsInitialized, service.id, exclusive]);

  return {
    addons,
    totalCount,
    isLoading: !!service.has_available_addons && isLoading,
    isFetching,
  };
};